import { Component,OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { flattenJSON } from 'src/app/Core/utils/flattenJSON';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/Core/services/user.service';

@Component({
  selector: 'app-ota-job-detail',
  templateUrl: './ota-job-detail.component.html',
  styleUrls: ['./ota-job-detail.component.css']
})
export class OTAJobDetailComponent implements OnInit {
  OTAID: any;
  OTA_data:any;
  flattenedData: { [key: string]: any } = {};
  public tableHeaders: string[]=[]

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) =>{
      this.OTAID=params.get('id') || '';
      this.fetchOTA();
    });
  }

  constructor(private http: HttpClient, private route: ActivatedRoute, private userService: UserService) {
  
  }

  fetchOTA(){
    const apiUrl = `${environment.host}/ota-job/${this.OTAID}`;
    
    this.userService.fetchOTAData(this.OTAID).subscribe(
    (data:any)=>{
      this.OTA_data = data;
      this.flattenedData=flattenJSON(data);

      console.log(this.flattenedData);
    
      this.tableHeaders=Object.keys(this.flattenedData);
      console.log(this.tableHeaders);
    },
    (error:any)=>{
      console.error('Error in fetching the OTA Data',error);
    }
  );
  
}


}
